import { render, staticRenderFns } from "./TicketsDescargaMasivaListado.vue?vue&type=template&id=6dd0ced4"
import script from "./TicketsDescargaMasivaListado.vue?vue&type=script&lang=js"
export * from "./TicketsDescargaMasivaListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports